import Framework7 from 'framework7/framework7.esm.bundle.js'

export type DeviceType = 'android' | 'ios' | 'desktop'

export const type: DeviceType =
  Framework7.device.android ? 'android' :
    Framework7.device.ios ? 'ios' : 'desktop'
